import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

// 学習画面選択情報取得
export namespace ApiTaSf010 {
  // GET
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        courseId: string // コースID
        planId: string // プランID
        levelId: string // レベルID
        memberGrade?: number // 会員学年
        teachingMaterialType?: number // 教材種別
      }
    }

    // API Response
    export interface SubjectNode {
      subjectId: string // 教科ID
      name: string // 教科名称
    }
    export interface Response {
      memberGrade: number[] // 会員学年
      attendanceSubject: SubjectNode[] // 受講教科
    }

    // API Path
    // ※ 2023年3月に環境変数 ENABLE_FUNCTION_LEARNING_INFORMATION_V2 を true とすることで呼び出すバージョンを v2 とする。
    //   その状態で1ヶ月ほど運用した後、下記制御はv2固定に変更すること。（環境変数も破棄する）
    export const path: string =
      process.env.ENABLE_FUNCTION_LEARNING_INFORMATION_V2?.toLowerCase() === 'true'
        ? 'v2/ta/learningInformation'
        : 'ta/learningInformation'
  }

  // API本体
  export class Api
    extends ApiBase
    implements Gettable<Get.Request, Get.Response, ResponseError>
  {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        memberGrade: [0],
        attendanceSubject: [
          {
            subjectId: '',
            name: '',
          }
        ],
      }
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
